import {Component, EventEmitter, Output} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-delete-all-notification-dialog',
  templateUrl: './delete-all-notification-dialog.component.html',
  styleUrls: ['./delete-all-notification-dialog.component.scss']
})
export class DeleteAllNotificationDialogComponent {

  @Output() deleteAllNotification: EventEmitter<void> = new EventEmitter<void>()

  constructor(
    private modalService: ModalService
  ) {
  }

  deletePaylink() {
    this.deleteAllNotification.emit()
  }

  closeModal() {
    this.modalService.closeModal()
  }
}
